import type { User } from '@/lib/auth';

const BUILDER_ROLES = new Set(['platform_admin', 'group_owner', 'group_admin']);
const BUILDER_GRANTS = new Set(['builder:read', 'builder:*', 'business-builder:read', 'business-builder:*']);

function hasBuilderGrant(grants?: string[]): boolean {
  return (grants ?? []).some((grant) => BUILDER_GRANTS.has(grant) || grant === '*:read' || grant === '*:*');
}

export function isBuilderAccountUser(user: Pick<User, 'role' | 'grants'> | null | undefined): boolean {
  const role = user?.role ?? '';
  return BUILDER_ROLES.has(role) || hasBuilderGrant(user?.grants);
}
